import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { CoreSliceReducer } from "./slices/CoreSlice";
import { AuthSliceReducer } from "./slices/AuthSlice";
import { CurrentUserSliceReducer } from "./slices/CurrentUserSlice";

export const ReduxStore = configureStore({
	reducer: {
		core: CoreSliceReducer,
		auth: AuthSliceReducer,
		currentUser: CurrentUserSliceReducer,
	},
});
export type ReduxState = ReturnType<typeof ReduxStore.getState>;
export type TypedDispatch = typeof ReduxStore.dispatch;

export const useTypedDispatch: () => TypedDispatch = useDispatch;
export const useTypedSelector: TypedUseSelectorHook<ReduxState> = useSelector;
